export const ACTIVITY_PULSE_COALESCE_MS = 220;
export const ACTIVITY_PULSE_DURATION_MS = 400;
export const ACTIVITY_PULSE_LUMINOSITY_BOOST = 0.18;
export const ACTIVITY_PULSE_MAX_BOOST = 0.36;

export type ActivityPulseState = {
  intensity: number;
  startedAt: number;
  expiresAt: number;
};

/**
 * Coalesce rapid dimension/feedback signals within 220ms into one bounded pulse.
 */
export function coalesceActivityPulse(
  prev: ActivityPulseState | null,
  now: number,
): ActivityPulseState {
  if (prev && now - prev.startedAt < ACTIVITY_PULSE_COALESCE_MS) {
    return {
      startedAt: prev.startedAt,
      intensity: Math.min(
        prev.intensity + ACTIVITY_PULSE_LUMINOSITY_BOOST * 0.5,
        ACTIVITY_PULSE_MAX_BOOST,
      ),
      expiresAt: now + ACTIVITY_PULSE_DURATION_MS,
    };
  }
  return {
    startedAt: now,
    intensity: ACTIVITY_PULSE_LUMINOSITY_BOOST,
    expiresAt: now + ACTIVITY_PULSE_DURATION_MS,
  };
}

export function getPulseLuminosityBoost(
  pulse: ActivityPulseState | null,
  now: number,
): number {
  if (!pulse || now > pulse.expiresAt) return 0;
  const remaining = (pulse.expiresAt - now) / ACTIVITY_PULSE_DURATION_MS;
  return pulse.intensity * Math.max(0, remaining);
}
